const statuses = {
	pending: 'pending',
	approved: 'approved',
	rejected: 'rejected',
	trash: 'trash'
};

const locale = {
	ru: {
		pending: 'в обработке',
		approved: 'подтверждена',
		rejected: 'отклонена',
		trash: 'невалидная'
	},
	en: statuses,
	uk: statuses,
	de: {
		pending: 'bevorstehend',
		approved: 'bestätigt',
		rejected: 'abgelehnt',
		trash: 'Müll'
	},
	vi: {
		pending: 'đang xử lý',
		approved: 'đã xác nhận',
		rejected: 'bị từ chối',
		trash: 'không hợp lệ'
	},
	th: {
		pending: 'กำลังดำเนินการ',
		approved: 'ยืนยันแล้ว',
		rejected: 'ปฏิเสธแล้ว',
		trash: 'ใช้ไม่ได้'
	}
};

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/conversion-statuses.js